// @flow

import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import QRCode from 'react-qr-code';
import { __ } from '../../../i18n/l10n';
import { BettingUrl, getAppleStorePath, getGooglePlayPath, PokerUrl } from '../../../config/paths';
import imagePictureMobile from '../../../assets/images/picto_parcour_parier.png';
import imagePictureDesktop from '../../../assets/images/picto_parcour_poker.png';
import { Button, Push, StoreBadge } from '..';
import { colorPalette, sizes } from '../../../styles/GlobalStyle';
import { isIOS, isAndroid } from '../../../lib/useragent';
import config from '../../../config/app.config';
import { BasePath } from '../../../config/paths';

type GroupPushRawProps = {
  className?: string,
};

const Container = styled.div`
  width: 100%;
`;

const StyledPush = styled(Push)`
  margin-bottom: 10px;
  height: inherit;
`;

const PlayButton = styled(Button)`
  font-size: ${rem('22px')};
  height: 90px;
  margin-bottom: 20px;

  .inner {
    justify-content: center;
  }

  &:after {
    content: '';
    position: absolute;
    left: calc(50% - 20px);
    bottom: -19px;
    border-top: 20px solid ${colorPalette.primary.active};
    border-right: 20px solid transparent;
    border-left: 20px solid transparent;

    transition: 300ms all ease-out;
  }

  &:hover {
    &:after {
      border-top-color: ${colorPalette.primary.hover};
    }
  }
`;

const PlayText = styled.div`
  text-transform: uppercase;
  text-align: center;
  font-size: ${rem('20px')};
  font-weight: 900;
  letter-spacing: 0.6px;
  margin-top: ${sizes.padding};
`;

const ArrowDown = styled.div`
  margin: 10px auto;
  width: 20px;
  border-top: 20px solid ${colorPalette.primary.active};
  border-right: 20px solid transparent;
  border-left: 20px solid transparent;

  &:after {
    content: '';
    position: absolute;
    margin-top: -18px;
    margin-left: -16px;
    border-top: 16px solid ${colorPalette.primary.foreGround};
    border-right: 16px solid transparent;
    border-left: 16px solid transparent;
  }
`;

const StoreBadges = styled.div`
  display: flex;
  justify-content: center;
`;

const QRContainer = styled.div`
  text-align: center;
  margin: ${sizes.padding};
`;

export const GroupPush = ({ className }: GroupPushRawProps) => {
  const handleClickPlayApp = () => {
    const anchor = document.createElement('a');
    anchor.href = isIOS ? getAppleStorePath(config.license) : isAndroid ? getGooglePlayPath() : '';
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.click();
  };

  return (
    <>
      <Container className={`${className || ''} groupPush`}>
        <StyledPush
          title={__('Bet on sports')}
          subtitle={__('The best odds are your odds')}
          visual={imagePictureMobile}
          url={BettingUrl}
        />
        <StyledPush
          title={__('Play poker')}
          subtitle={__('Come and take a seat')}
          visual={imagePictureDesktop}
          url={PokerUrl}
        />
      </Container>
      {(isIOS || isAndroid) && !config.isEmbedded && (
        <>
          <PlayButton type="submit" theme="primary" onClick={handleClickPlayApp}>
            {__('Play on the app !')}
          </PlayButton>

          <StoreBadges>
            {!isAndroid && (
              <a href={getAppleStorePath(config.license)} target="_blank" rel="noopener noreferrer">
                <StoreBadge name={`apple-store-${config.license.toLowerCase()}`} />
              </a>
            )}
            {!isIOS && (
              <a href={getGooglePlayPath()} target="_blank" rel="noopener noreferrer">
                <StoreBadge name={`google-play-${config.license.toLowerCase()}`} />
              </a>
            )}
          </StoreBadges>
        </>
      )}
      {!isIOS && !isAndroid && (
        <>
          <PlayText>{__('Play on the app !')}</PlayText>
          <ArrowDown />
          <StoreBadges>
            <StoreBadge name={`apple-store-${config.license.toLowerCase()}`} />
            <StoreBadge name={`google-play-${config.license.toLowerCase()}`} />
          </StoreBadges>
          <QRContainer>
            <QRCode
              value={`${window.location.origin}${BasePath}/redirect/store`}
              bgColor="#000000"
              fgColor="#FFFFFF"
              size={150}
            />
          </QRContainer>
        </>
      )}
    </>
  );
};
